export default {
  SET_SUCCESS_GOVERNMENTS: (state, success) =>
    (state.governments_success = success),
  SET_SUCCESS_REGiONS: (state, success) => (state.regions_success = success),
  SET_ERRORS: (state, errors) => (state.errors = errors),
  SET_ERROR_MSG: (state, error_msg) => (state.error_msg = error_msg),
  SET_GOVERNMENTS: (state, governments) => (state.governments = governments),
  SET_REGiONS: (state, regions) => (state.regions = regions),
};
